import React from 'react';

const NotFound = () => {
    return (
        <div>
            <h1 style={{ padding: '50px' }} > This Route isNot Exist</h1>

        </div>
    );
};

export default NotFound;